module.exports = __webpack_public_path__ + "img/activ8-logo.aab5ee34.png";